import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=f8cc6d94&scoped=true&"
import script from "./BoxItem.vue?vue&type=script&lang=js&"
export * from "./BoxItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxItem.vue?vue&type=style&index=0&id=f8cc6d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cc6d94",
  null
  
)

export default component.exports